import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_1.jpg'
import StoryImage from '../../images/about1.jpg'
import VisionImage from '../../images/about2.jpg'
import MissionImage from '../../images/about3.jpg'

import './about.css'

const About = () => {
  return (
    <>
    <Header title="About Us" image={HeaderImage}>
      Lorem, ipsum dolor sit amet consectetur adipisicing elit.
       veniam ab quidem corrupti, cupiditate doloribus pariatur.
    </Header>

    <section className='about__story'>
      <div className="container about_story-container">
        <div className="about__section-image">
          <img src={StoryImage} alt="Our Story" />
        </div>
        <div className="about__section-content"> 
          <h1>OUR STORY</h1>
          <p>
            Lorem ipsumi. ne tempore sunt, illum quisquam nisi 
            deserunt praesentium voluptate placeat?
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Amet, ea est cumque neque omnis unde quae voluptatem velit 
            nulla magni veniam, perferendis nostrum exercitationem, 
            quam esse voluptatum ratione iusto repudiandae.
          </p>
        </div>
      </div>
    </section>

    <section className='about__vision'>
      <div className="container about_vision-container">
        
        <div className="about__section-content"> 
          <h1>OUR VISION</h1>
          <p>
            Lorem ipsumi. ne tempore sunt, illum quisquam nisi 
            deserunt praesentium voluptate placeat?
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Amet, ea est cumque neque omnis unde quae voluptatem velit 
            nulla magni veniam, perferendis nostrum exercitationem, 
            quam esse voluptatum ratione iusto repudiandae.
          </p>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nisi, 
            dignissimos laboriosam id eveniet soluta odio 
          </p>
        </div>
        <div className="about__section-image">
          <img src={VisionImage} alt="Our Vsion" />
        </div>
      </div>
    </section>

    <section className='about__mission'>
      <div className="container about_mission-container">
        <div className="about__section-image">
          <img src={MissionImage} alt="Our Mission" />
        </div>
        <div className="about__section-content"> 
          <h1>OUR MISSION</h1>
          <p>
            Lorem ipsumi. ne tempore sunt, illum quisquam nisi 
            deserunt praesentium voluptate placeat?
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Amet, ea est cumque neque omnis unde quae voluptatem velit 
            nulla magni veniam, perferendis nostrum exercitationem, 
            quam esse voluptatum ratione iusto repudiandae.
          </p>
          <p>
            Lorem ipsumi. ne tempore sunt, illum quisquam nisi 
            deserunt praesentium voluptate placeat?
          </p>
        </div>
      </div>
    </section>
    </>
  )
}

export default About